import { Theme } from './symbols';

export const optimisticTheme: Theme = {
  name: 'optimistic',
  properties: {
    '--primary-color': 'rgba(217, 83, 79, 1)',
    '--primary-light': 'rgba(217,83,79,0.1)',
    '--secondary-color': 'rgba(136, 136, 136, 1)',
    '--complementary-color': 'rgba(39,54,85,1)',
  }
};